import React, { useRef, useState } from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { CartType } from '@base/cart/useCart'
import BonusProdItem from '@base/cart/BonusProdItem'
import { IThemeSwiperRef, ThemeSwiper } from '@base/lib/ThemeSwiper'
import homeStyles from '@app/shop/index.module.less'
import { BONUS_ITEMS_DETAIL_HIDDEN_ELEMENTS } from '@base/cart/constant';
import { ProductDetailPopup } from '@app/common/ProductDetailPopup';

type IBonusItemListProps = {
    className?: string;
    cart: CartType;
    miniCartLinked?: boolean;
};

const BonusItemList: React.FC<IBonusItemListProps> = (props) => {
    const [detailVisible, setDetailVisible] = useState<boolean>(false);
    const [variantId, setVariantId] = useState<string>();

    const {
        cart: {
            bonusProdListData,
            onBonusProdSelect,
        } = {},
        miniCartLinked = false
    } = props;

    const onQuickView = (variantId: string) => {
        setDetailVisible(true);
        setVariantId(variantId)
    }

    const swiperRef = useRef<IThemeSwiperRef>(null);

    return (
        <>
            <ProductDetailPopup
                visible={detailVisible}
                onClose={() => setDetailVisible(false)}
                variantId={variantId}
                hiddenElements={BONUS_ITEMS_DETAIL_HIDDEN_ELEMENTS}
            />

            <div
                className={cn(
                    'bonus-products-wrap',
                    styles['bonus-products-wrap']
                )}
            >
                <p className="tips">{bonusProdListData?.tip}</p>

                <div>
                    <ThemeSwiper
                        ref={swiperRef}
                        slidesPerView={'auto'}
                        spaceBetween={12}
                        pagination={false}
                        className={cn(styles.swiper, homeStyles.swiper)}
                        navigation
                        navigationHideWhenDisabled
                        list={bonusProdListData?.items}
                        render={productItem => (
                            <BonusProdItem
                                onQuickView={onQuickView}
                                key={productItem.variantId}
                                miniCartLinked={miniCartLinked}
                                bonusProduct={productItem}
                                onBonusProdSelect={onBonusProdSelect}
                            />

                        )}
                    />
                </div>
            </div>
        </>
    );
};

export default BonusItemList